import DOMPurify from 'dompurify';

/**
 * Strips all HTML tags and dangerous content from a string.
 * Use this on any user-provided text before sending it to the backend.
 */
export function sanitizeText(value) {
  if (typeof value !== 'string') return value;
  // FORBID_TAGS removes the tags entirely rather than escaping them
  return DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim();
}

/**
 * Sanitizes every string value in a plain object one level deep.
 * Useful for sanitizing formData objects before API calls.
 */
export function sanitizeObject(obj) {
  const result = {};
  for (const [key, value] of Object.entries(obj)) {
    result[key] = typeof value === 'string' ? sanitizeText(value) : value;
  }
  return result;
}